var _a;
import { StatusItemAnalise } from '../../../enums/analise.enum';
export var COLOR_APROVADO = '#E6EFE6';
export var COLOR_REPROVADO = '#FAE6E6';
export var BG_COLORS_APROVACAO = (_a = {},
    _a[StatusItemAnalise.APROVADO] = COLOR_APROVADO,
    _a[StatusItemAnalise.REPROVADO] = COLOR_REPROVADO,
    _a);
export var getBgColorAprovacao = function (statusItem) {
    var _a;
    if (!statusItem) {
        return 'transparent';
    }
    return (_a = BG_COLORS_APROVACAO[statusItem]) !== null && _a !== void 0 ? _a : 'transparent';
};
